import { CIDService } from "src/app/services/common/cid.service";
import { LevelInfoService } from "./../../../../../../services/http/business/levelInfo/level-info.service";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngstack/translate";
import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatPaginator,
  MatTableDataSource,
  MatDialog,
  MatSelect
} from "@angular/material";

import { ILevelPrice } from "src/app/interfaces/level-price";
import { LevelPriceEntryComponent } from "../level-price-entry/level-price-entry.component";
import { ILevelInfo } from "src/app/interfaces/levelInfo";
import { ICompany } from "src/app/interfaces/company";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { CourseTypeService } from "src/app/services/http/business/course-type/course-type.service";
import { ICourseType } from "src/app/interfaces/course-type";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { LevelPriceService } from "src/app/services/http/business/level-price/level-price.service";
import { IConfirm } from "src/app/interfaces/confirm";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { SoundEnum } from "src/app/enums/sound.enum";
import { LevelInfoPrerequisiteService } from "src/app/services/http/business/levelInfo-prerequisite/level-info-prerequisite.service";

@Component({
  selector: "app-level-price-list",
  templateUrl: "./level-price-list.component.html",
  styleUrls: ["./level-price-list.component.css"]
})
export class LevelPriceListComponent implements OnInit {
  test: any;
  levelId: number;
  pageSize: number;
  isOwner: boolean;
  pageIndex: number;
  courseTypeId: number;
  compnayList: ICompany;
  companySelected: string;
  courseTypeSelected: number;
  levelInfoList: ILevelInfo;
  courseTypeList: ICourseType[];
  levelPrequisiteData: any = [];
  levelData: any = [];
  packageData: any = {
    PackageId: 0
  };
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource = new MatTableDataSource<ILevelPrice>();
  displayedColumns: string[] = [
    "branch",
    // this.translate.get("label.level"),
    "price",
    this.translate.get("label.courseType"),
    this.translate.get("label.creditStartDate"),
    this.translate.get("label.hasDiscount"),
    this.translate.get("label.isUsed"),
    "status",
    "function"
  ];

  constructor(
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private cidService: CIDService,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private companyService: CompanyService,
    private holdingService: HoldingService,
    private levelInfoService: LevelInfoService,
    private courseTypeService: CourseTypeService,
    private levelPriceService: LevelPriceService,
    private prerequisiteService: LevelInfoPrerequisiteService
  ) {
    route.params.subscribe(res => {
      this.packageData = res;
    });
  }

  ngOnInit() {
    this.checkOwner();
    this.getLevelList();
    this.refresh();
    this.companySelected = this.cidService.getCID();
    if (!this.isOwner) {
      this.getLevelList();
      this.getCourseType();
    }
    this.levelPriceService.getList(this.levelId, 0).subscribe(res => {
      this.dataSource = res.DataList;
      this.paginator.length = res.Total;
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 10;
    });
  }

  refresh() {
    this.route.params.subscribe(res => {
      this.packageData = res;
      this.levelId = res.bid;
      this.levelInfoService.getById(res.bid).subscribe(levelInfo => {
        this.levelData = levelInfo;
      });
      this.prerequisiteService.getLevelInfo(res.bid).subscribe(re => {
        this.levelPrequisiteData = re;
      });
    });
  }

  paginatorEvent(event) {
    this.levelPriceService
      .getList(this.levelId, this.courseTypeId, event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex + 1;
        this.dataSource = res.DataList;
        this.paginator.length = res.Total;
      });
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
      }
    });
  }

  add() {
    this.dialog
      .open(LevelPriceEntryComponent, {
        width: "450px",
        data: this.levelData
      })
      .afterClosed()
      .subscribe(() => {
        this.levelPriceService
          .getList(this.levelId, this.courseTypeId)
          .subscribe(re => {
            this.dataSource = re.DataList;
            this.paginator.pageIndex = 0;
            this.paginator.length = re.Total;
          });
      });
  }

  edit(item) {
    this.dialog
      .open(LevelPriceEntryComponent, {
        width: "450px",
        data: {
          editable: true,
          Id: item.Id,
          LevelId: item.LevelId,
          BranchEncryptId: item.BranchEncryptId,
          Price: item.Price,
          CourseTypeId: item.CourseTypeId,
          CreditStartDate: item.CreditStartDate,
          ContainDiscount: item.ContainDiscount,
          CourseTypeName: item.CourseTypeName,
          LevelName: item.LevelName
        }
      })
      .afterClosed()
      .subscribe(() => {
        this.levelPriceService
          .getList(this.levelId, this.courseTypeId)
          .subscribe(re => {
            this.dataSource = re.DataList;
            this.paginator.pageIndex = 0;
            this.paginator.length = re.Total;
          });
      });
    // Id: [0],
    //   LevelId: [this.data.Id, Validators.compose([Validators.required])],
    //   BranchEncryptId: [null],
    //   Price: [null, Validators.compose([Validators.required])],
    //   CourseTypeId: [null, Validators.compose([Validators.required])],
    //   CreditStartDate: [null, Validators.compose([Validators.required])],
    //   ContainDiscount: [false, Validators.compose([Validators.required])]
  }

  getLevelList() {
    this.levelInfoService
      .getList(this.packageData.packageId, 0, 0)
      .subscribe(res => {
        this.levelInfoList = res.DataList;
      });
  }

  // setLevelId(e: MatSelect) {
  //   this.levelId = e.value;
  //   this.dataSource = null;
  //   this.paginator.length = 0;
  //   if (this.courseTypeId !== undefined) {
  //     this.levelPriceService
  //       .getList(this.levelId, this.courseTypeId)
  //       .subscribe(re => {
  //         this.dataSource = re.DataList;
  //         this.paginator.pageIndex = 0;
  //         this.paginator.length = re.Total;
  //       });
  //   }
  // }

  setCid(e: MatSelect) {
    this.cidService.setCID(e.value);
    this.getCourseType();
    this.courseTypeSelected = 0;
  }

  getCourseType() {
    this.courseTypeService.list(0, 0).subscribe(res => {
      this.courseTypeList = [];
      this.courseTypeList.push({ Title: "همه دوره ها", Id: 0, Active: true, Branchs: null })
      res.DataList.forEach(element => {
        this.courseTypeList.push(element);
      });
    });
  }

  loadDataSource(e: MatSelect) {
    this.courseTypeId = e.value;
    this.levelPriceService.getList(this.levelId, e.value).subscribe(res => {
      this.dataSource = res.DataList;
      this.paginator.length = res.Total;
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 10;
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.compnayList = res.DataList;
    });
  }



  delete(data: ILevelPrice): void {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.delete", {
        name: this.translate.get("label.level") + " " + data.LevelName
      }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        var xdata = {
          Id: data.Id
        };
        this.levelPriceService.delete(xdata).subscribe(
          () => {
            this.levelPriceService
              .getList(this.levelId, this.courseTypeId)
              .subscribe(re => {
                this.dataSource = re.DataList;
                this.paginator.length = re.Total;
              });
          },
          () => {
            this.snackBar.OpenSnackBar(
              this.translate.get("error.lvelPrice"),
              "ok",
              5000,
              SoundEnum.beep
            );
          }
        );
      }
    });
  }
}
